import React from 'react';

export default function SendIcon(props) {
  return (
    <div className={props.className} alt={props.alt}>
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.344578 3.43385C-0.278648 1.56416 1.63257 -0.146462 3.422 0.679429L13.7737 5.45714C15.5165 6.26153 15.5165 8.73858 13.7737 9.54296L3.422 14.3206C1.63258 15.1465 -0.278644 13.4359 0.344586 11.5662L1.4628 8.21157C1.61676 7.74972 1.61676 7.25039 1.46281 6.78854L0.344578 3.43385ZM2.79341 2.04137L13.1451 6.81908C13.726 7.08721 13.726 7.91289 13.1451 8.18102L2.79342 12.9587C2.19694 13.234 1.55987 12.6638 1.76761 12.0406L2.88583 8.68591C2.93363 8.54251 2.97252 8.39695 3.00251 8.25003H9.19998C9.6142 8.25003 9.94998 7.91424 9.94998 7.50003C9.94998 7.08581 9.6142 6.75003 9.19998 6.75003H3.0025C2.97251 6.60312 2.93362 6.45758 2.88583 6.3142L1.7676 2.95951C1.55986 2.33628 2.19694 1.76607 2.79341 2.04137Z"
          fill={props.color}
        />
      </svg>
    </div>
  );
}
